export default "__VITE_ASSET__DOSqYT38__"